import api from './api';

export async function getFeedback({ page = 1, limit = 10, rating, search } = {}) {
  const params = { page, limit };

  if (rating) params.rating = rating;
  if (search) params.search = search;

  const response = await api.get('/admin/feedback', { params });
  return response.data;
}
